import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
gsap.registerPlugin(ScrollTrigger);

export default function gsapAnimation() {
  let isMobile = window.innerWidth < 1000;
  function fade() {
    const targets = gsap.utils.toArray('[gsap-fade]');
    targets.forEach(target => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: target,
          start: '10% 50%',
          end: 'top 20%',
        },
      });
      tl.fromTo(
        target,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 2,
          ease: 'power2.out',
        },
      );
    });
  }
  function fadeUp() {
    const targets = gsap.utils.toArray('[gsap-fade-up]');
    targets.forEach((target, index) => {
      const start = targets.length - 1 === index ? 'top bottom' : `-70% ${isMobile ? '80%' : '50%'}`;
      const end = targets.length - 1 === index ? 'bottom+=100% bottom' : 'top 20%';
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: target,
          start: start,
          end: end,
          // markers: true,
        },
      });
      tl.from(target, {
        y: '70%',
        opacity: 0,
        duration: 1,
        ease: 'power2.out',
      });
    });
  }
  function reportAnimate() {
    const reportGrids = gsap.utils.toArray('.report-list .grid');
    gsap.from(reportGrids, {
      opacity: 0,
      y: 30,
      duration: 0.8,
      stagger: 0.5,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: reportGrids[0],
        start: 'top 50%',
        end: 'bottom 50%',
      },
    });
  }

  fade();
  fadeUp();
  reportAnimate();
}
